import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import KDatePicker from "../components/KDatePicker";
import moment from "moment";
import { FilterOptions } from "../models/DashboardModels";
import { DEFAULT_OPTION, MIN_DATE_REPORTS, MIN_YEAR_REPORTS } from "../utils/Constant";
import SelectBox from "../components/SelectBox";
import { useSelector } from "react-redux";
import { FormUtils } from "../utils/FormUtils";
import { toast } from "react-toastify";

interface ViewFilterProps {
  onApplyFilters: (viewFilter: FilterOptions) => void;
}

export const DownloadReportsFilters = ({
  onApplyFilters,
}: ViewFilterProps) => {
  const [viewFilter, setViewFilter] = useState<FilterOptions>({
    dateFrom: undefined,
    dateTo: undefined,
    lob: DEFAULT_OPTION,
  });


  const onResetFilter = () => {
    const resetFilter = {
      dateFrom: undefined,
      dateTo: undefined,
      lob: DEFAULT_OPTION,
    };
    onApplyFilters(resetFilter);
    setViewFilter(resetFilter);
  };

  
  const {
    storeLOBData,
  } = useSelector((state: any) => state.grievances);
  
  const lobData = FormUtils.convertDataList(
    storeLOBData.data?? []
  );

  const [disable, setDisable] = useState(true);
  useEffect(() => {
    const currentDate = new Date();

    if (!viewFilter?.dateFrom) {
      setDisable(true);
      return;
    }

    const startDate = new Date(viewFilter.dateFrom.getTime());

    if (startDate > currentDate) {
      toast.error('Start date cannot be in the future.');
      setDisable(true);
      return;
    }

    if (startDate.getFullYear() < MIN_YEAR_REPORTS) {
      toast.error(`Start date cannot be before ${MIN_YEAR_REPORTS}.`);
      setDisable(true);
      return;
    }

    if (!viewFilter?.dateTo) {
      setDisable(true);
      return;
    }

    const endDate = new Date(viewFilter.dateTo.getTime());

    if (endDate > currentDate) {
      toast.error('End date cannot be in the future.');
      setDisable(true);
      return;
    }

    if (endDate.getFullYear() < MIN_YEAR_REPORTS) {
      toast.error(`End date cannot be before ${MIN_YEAR_REPORTS}.`);
      setDisable(true);
      return;
    }

    if (endDate < startDate) {
      toast.error('End date cannot be before start date.');
      setDisable(true);
      return;
    }

    if (moment(viewFilter.dateTo).isAfter(moment(viewFilter.dateFrom).add(1, 'years'))) {
      toast.error('Date range cannot be more than 1 year.');
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [viewFilter]);


  return (
    <div className="border rounded ps-3 pt-2 pe-3 pb-3 mb-3">
      <Row className="mb-3">
        <Col xs={6} md={3}>
          <KDatePicker
            label="Date From"
            value={viewFilter.dateFrom}
            minDate={viewFilter?.dateTo ? 
              moment(viewFilter.dateTo).subtract(1, 'year').isBefore(moment(MIN_DATE_REPORTS)) ? 
                moment(MIN_DATE_REPORTS).toDate() : 
                moment(viewFilter.dateTo).subtract(1, 'year').toDate() : 
              moment(MIN_DATE_REPORTS).toDate()}
            maxDate={viewFilter?.dateTo ?? new Date()}
            onChange={(date) => {
              setViewFilter({
                ...viewFilter,
                dateFrom: date,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <KDatePicker
            label="Date To"
            value={viewFilter.dateTo}
            minDate={viewFilter.dateFrom ?? moment(MIN_DATE_REPORTS).toDate()}
            maxDate={viewFilter.dateFrom ? 
              moment(viewFilter.dateFrom).add(1, 'year').isAfter(new Date()) ? 
                new Date() : 
                moment(viewFilter.dateFrom).add(1, 'year').toDate() : 
              new Date()}
            onChange={(date) => {
              setViewFilter({
                ...viewFilter,
                dateTo: date,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectBox
            label="Line of Business"
            options={lobData}
            className="css-select-bg"
            value={viewFilter.lob}
            onChange={(value: any) => {
              setViewFilter({
                ...viewFilter,
                lob: value,
              });
            }}
          />
        </Col>
      </Row>
      <Row >
        <Col xs={6} md={3} className="d-flex align-items-center mb-2 buttons-container">
          <button
            className="button"
            onClick={() => {
              onApplyFilters(viewFilter);
            }}
            disabled={disable}
          >
            {" "}
            Apply Filters{" "}
          </button>
          <button
            className="resetButton"
            onClick={() => {
              onResetFilter();
            }}
          >
            {" "}
            Reset{" "}
          </button>
        </Col>
      </Row>
    </div>
  );
};
